module.exports = __webpack_public_path__ + "static/knowledge_topic.52048fcd.png";